import './index.css'
import cn from 'clsx'
import * as React from 'react'
import InlineSVG from 'svg-inline-react'
import type { EmailTemplate } from 'types/content-editor'
export default class CampaignTemplatePreview extends React.Component<{
  selected: boolean
  template: EmailTemplate
  onSelect: () => unknown
}> {
  _renderPreview(templateId: string): React.ReactNode {
    switch (templateId) {
      case 't1':
        return (
          <InlineSVG
            className="CampaignTemplatePreview_PreviewRoot"
            src={require('!svg-inline!assets/images/campaign-template-preview-t1.svg')}
          />
        )

      case 't3':
        return (
          <InlineSVG
            className="CampaignTemplatePreview_PreviewRoot"
            src={require('!svg-inline!assets/images/campaign-template-preview-t3.svg')}
          />
        )

      default:
        throw new Error(
          `Error: switch (templateId): no match found for value ${JSON.stringify(
            templateId,
          )}`,
        )
    }
  }

  render(): null | React.ReactElement<'div'> {
    const { selected, template } = this.props
    if (!template) return null
    return (
      <div className="CampaignTemplatePreview" onClick={this.props.onSelect}>
        <div className="CampaignTemplatePreview_Name">{template.name}</div>
        <div
          className={cn('CampaignTemplatePreview_Preview', {
            selected,
          })}
        >
          {template.id ? this._renderPreview(template.id) : null}
        </div>
      </div>
    )
  }
}
